module.exports = "/_next/static/images/7e791876c5ab4444253d6a59ec867fa2-green-check.svg.webp";